import { render } from "./CookContactComponent.vue?vue&type=template&id=c0ceefa4&scoped=true"
import script from "./CookContactComponent.vue?vue&type=script&lang=js"
export * from "./CookContactComponent.vue?vue&type=script&lang=js"

import "./CookContactComponent.vue?vue&type=style&index=0&id=c0ceefa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0ceefa4"]])

export default __exports__